module.exports = __webpack_public_path__ + "Material-Design-Icons.4c874dce20349e350c4a.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/material-design-icons/Material-Design-Icons.woff
// module id = ../../../../../src/assets/font/material-design-icons/Material-Design-Icons.woff
// module chunks = 29